<template>
  <div>
    <CreateNewInvoice v-if="!forUpdate"></CreateNewInvoice>
    <UpdateInvoice v-if="forUpdate" :id="id"></UpdateInvoice>
  </div>
</template>

<script>
  import CreateNewInvoice from '@/views/accountant/CreateNewInvoice.vue'
  import UpdateInvoice from '@/views/accountant/UpdateInvoice.vue'

  export default {
    name: 'InvoiceCreateNew',
    data: () => ({
      id: null
    }),
    watch: {
    },
    computed: {
      forUpdate: function(){
        return this.id ? true : false
      }
    },
    methods: {
    },
    mounted() {
      if(this.$route.params.id != 'add'){
        this.id = this.$route.params.id
      }
    },
    components: {
      CreateNewInvoice,
      UpdateInvoice
    }
  }
</script>
